import Flatpickr from "react-flatpickr";
import { CalendarClock } from "lucide-react";
import "flatpickr/dist/flatpickr.css";

export function DateTimeField({
  id,
  value,
  onChange,
  showTime = true,
  minDate,
  maxDate,
  placeholder = "Select date…",
  required,
  disabled,
}) {
  return (
    <div className="ops-datefield">
      <Flatpickr
        id={id}
        className="ops-input"
        value={value || undefined}
        onChange={([date]) => onChange(date || null)}
        options={{
          enableTime: showTime,
          dateFormat: showTime ? "M j, Y h:i K" : "M j, Y",
          minDate: minDate || undefined,
          maxDate: maxDate || undefined,
          disableMobile: true,
        }}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
      />
      <CalendarClock size={16} className="ops-datefield-icon" />
    </div>
  );
}
